import React from 'react';
import { CreateOutlined } from '@mui/icons-material';
import styled from 'styled-components';
import TooltipIconButton from "components/TooltipIconButton";
import TextButton from "components/TextButton";

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 0 0 2rem;
  &:not(.edit) {
    position: absolute;
    top: -6px;
    right: 0;
  }
`;

const HeaderSection = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;

  h2 {
    margin-bottom: 0;
  }
`;

// TO DO - handle saving
const ProjectEditBtn = ({ edit, handleEdit }) => (
  <Wrapper className={edit ? 'edit' : null}>
    {edit ?
      <HeaderSection>
        <h2>Settings</h2>
        <TextButton onClick={handleEdit} text="Save" />
      </HeaderSection>
    :
      <TooltipIconButton title="Edit" ariaLabel="edit" placement="bottom" onClick={handleEdit} size={44}>
        <CreateOutlined />
      </TooltipIconButton>
    }
  </Wrapper>
)

export default ProjectEditBtn;